import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import type { ModalProps } from './automation-free-limit-modal';

type AutomationLimitsEntryPointComponent = EntryPointComponent<
	Record<string, never>,
	Record<string, never>,
	ModalProps,
	Record<string, never>
>;

const AutomationLimitsEntryPoint: EntryPoint<AutomationLimitsEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<AutomationLimitsEntryPointComponent>(
			/* webpackChunkName: "@atlaskit-internal_edition-awareness-automation-free-limit-modal" */ './automation-free-limit-modal',
			{
				moduleId: 'edition-awareness-automation-free-limit-modal',
			},
		),
		getPreloadProps: () => ({
			entryPoints: {},
			extraProps: {},
			queries: {},
		}),
	});

export default AutomationLimitsEntryPoint;
